import React from "react";

import { StyledSVG } from "../StyledIcon";

export const GraphQLIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.36461 16.474C9.1381 16.5998 8.86267 16.5998 8.63615 16.474L2.49981 13.0649C2.26171 12.9326 2.11405 12.6817 2.11405 12.4093L2.11405 5.59113C2.11405 5.31875 2.26171 5.06779 2.49981 4.93551L8.63615 1.52644C8.86267 1.40059 9.1381 1.40059 9.36461 1.52644L15.501 4.93551C15.7391 5.06779 15.8867 5.31876 15.8867 5.59113L15.8867 12.4093C15.8867 12.6817 15.7391 12.9326 15.501 13.0649L9.36461 16.474ZM13.8121 11.6593L9.00038 3.63979L4.18869 11.6593L13.8121 11.6593ZM3.61405 9.70154L6.91625 4.19788L3.61405 6.03243L3.61405 9.70154ZM11.0845 4.19788L14.3867 6.03243L14.3867 9.70155L11.0845 4.19788ZM5.75839 13.1593L12.2424 13.1593L9.00038 14.9604L5.75839 13.1593Z"
        fill={iconColor}
      />
      <ellipse
        cx="9"
        cy="15.75"
        rx="1.5"
        ry="1.5"
        transform="rotate(-180 9 15.75)"
        fill="white"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse
        cx="15"
        cy="12.75"
        rx="1.5"
        ry="1.5"
        transform="rotate(-180 15 12.75)"
        fill="white"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse
        cx="15"
        cy="5.25"
        rx="1.5"
        ry="1.5"
        transform="rotate(-180 15 5.25)"
        fill="white"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse
        cx="3"
        cy="12.75"
        rx="1.5"
        ry="1.5"
        transform="rotate(-180 3 12.75)"
        fill="white"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse
        cx="3"
        cy="5.25"
        rx="1.5"
        ry="1.5"
        transform="rotate(-180 3 5.25)"
        fill="white"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse
        cx="9"
        cy="2.25"
        rx="1.5"
        ry="1.5"
        transform="rotate(-180 9 2.25)"
        fill="white"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledSVG>
  );
};
